/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WatchSchemaAllObjects } from './WatchSchemaAllObjects';
import {
    WatchSchemaAllObjectsFromJSON,
    WatchSchemaAllObjectsFromJSONTyped,
    WatchSchemaAllObjectsToJSON,
} from './WatchSchemaAllObjects';

/**
 * Configuration for monitoring provider schema changes.
 * @export
 * @interface WatchSchema
 */
export interface WatchSchema {
    /**
     * The destination to send schema change notifications to.
     * @type {string}
     * @memberof WatchSchema
     */
    destination: string;
    /**
     * Cron schedule for checking schema changes. Minimum frequency is once per hour. Defaults to once a day.
     * @type {string}
     * @memberof WatchSchema
     */
    schedule?: string;
    /**
     * 
     * @type {WatchSchemaAllObjects}
     * @memberof WatchSchema
     */
    allObjects: WatchSchemaAllObjects;
}

/**
 * Check if a given object implements the WatchSchema interface.
 */
export function instanceOfWatchSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "destination" in value;
    isInstance = isInstance && "allObjects" in value;

    return isInstance;
}

export function WatchSchemaFromJSON(json: any): WatchSchema {
    return WatchSchemaFromJSONTyped(json, false);
}

export function WatchSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatchSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'destination': json['destination'],
        'schedule': !exists(json, 'schedule') ? undefined : json['schedule'],
        'allObjects': WatchSchemaAllObjectsFromJSON(json['allObjects']),
    };
}

export function WatchSchemaToJSON(value?: WatchSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'destination': value.destination,
        'schedule': value.schedule,
        'allObjects': WatchSchemaAllObjectsToJSON(value.allObjects),
    };
}

